import { render, staticRenderFns } from "./CartSuiteTab.vue?vue&type=template&id=2f3281f6"
import script from "./CartSuiteTab.vue?vue&type=script&lang=ts"
export * from "./CartSuiteTab.vue?vue&type=script&lang=ts"
import style0 from "./CartSuiteTab.vue?vue&type=style&index=0&id=2f3281f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports